import {InspectionScheduleCadenceEnum} from 'src/api/ProactApiClient';
import {z} from 'zod';

// `intervalDays` is only meaningful (and required, 1–1000) for the Custom cadence.
export const scheduleFormSchema = z
  .object({
    siteId: z.string().min(1, 'Site is required'),
    inspectionTypeId: z.string().min(1, 'Inspection type is required'),
    cadence: z
      .number()
      .refine(
        value => value !== InspectionScheduleCadenceEnum.Invalid,
        'Cadence is required'
      ),
    intervalDays: z.number().int().min(1).max(1000).nullable(),
    anchorDate: z.date({invalid_type_error: 'Anchor date is required'}),
    leadTimeDays: z
      .number({invalid_type_error: 'Lead time is required'})
      .int()
      .min(0, 'Lead time cannot be negative'),
  })
  .superRefine((values, ctx) => {
    if (
      values.cadence === InspectionScheduleCadenceEnum.Custom &&
      values.intervalDays === null
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['intervalDays'],
        message: 'Interval is required for a custom cadence',
      });
    }
  });

export type ScheduleFormValues = z.infer<typeof scheduleFormSchema>;
